export default __webpack_public_path__ + "static/media/v13.92588fde.svg";